/**
 * Specific selectors
 */
const selectAccountsList = (state) => state.getIn(['workspaceAccounts', 'accounts']);
const selectTeamList = (state) => state.getIn(['workspaceTeams', 'teams']);
const selectWorkspacesList = (state) => state.getIn(['workspaceWorkspaces', 'workspaces']);
const selectWorkspacesLoadingState = (state) => state.getIn(['workspaceWorkspaces', 'loading']);
const selectTeamAccounts = (state, teamId) => {
  const team = state.getIn(['workspaceTeams', 'team', teamId]);
  return team && team.accounts;
};
const selectWorkspaceCollaborators = (state, workspaceId) => {
  const workspace = state.getIn(['workspaceWorkspaces', 'workspace', workspaceId]);

  return workspace && workspace.collaborators;
};
const selectWorkspace = (state) => state.getIn(['workspaceWorkspaces', 'selectedWorkspace']);

export {
  selectAccountsList,
  selectTeamList,
  selectWorkspacesList,
  selectWorkspacesLoadingState,
  selectTeamAccounts,
  selectWorkspaceCollaborators,
  selectWorkspace,
};
